module.exports = __webpack_public_path__ + "img/thumb_01.a9cb5e9c.jpg";